import { request } from "./http";

export const getSubscriptionPricing = () =>
  request<{
    currency: string;
    base: number;
    monthly: { amount: number; price_id: string | null; available: boolean };
    semiannual: { amount: number; price_id: string | null; available: boolean };
    annual: { amount: number; price_id: string | null; available: boolean };
  }>("/api/subscription/pricing");
